/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaginationPageInfo from '../PaginationPageInfo';
import PaginationNavigation from '../PaginationNavigation';

class PaginationBlock extends Component {
  handlePageClick = pageNumber => {
    this.props.handlePageClick(pageNumber);
  };

  render() {
    if (this.props.fixCount !== null) {
      return (
        <div className="clearfix">
          <div className="form-control-static pull-left">
            <PaginationPageInfo fixCount={this.props.fixCount} />
          </div>
        </div>
      );
    } else if (this.props.paginationData !== null) {
      return (
        <div className="clearfix">
          <div className="form-control-static pull-left">
            <PaginationPageInfo paginationData={this.props.paginationData} />
          </div>
          <div className="pull-right">
            <PaginationNavigation
              paginationData={this.props.paginationData}
              handlePageClick={this.handlePageClick}
            />
          </div>
        </div>
      );
    }
    return null;
  }
}

PaginationBlock.defaultProps = {
  paginationData: null,
  fixCount: null
};

PaginationBlock.propTypes = {
  paginationData: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }),
  fixCount: PropTypes.number,
  handlePageClick: PropTypes.func.isRequired
};

export default PaginationBlock;



// WEBPACK FOOTER //
// ./src/components/Common/Pagination/PaginationBlock/PaginationBlock.js